import { defineStore } from 'pinia'

type SharePayload = {
  uuid?: string
  title?: string
}

export const useShareModalStore = defineStore('shareModal', {
  state: () => ({
    open: false,
    songTitle: '' as string | undefined,
    songUuid: '' as string | undefined
  }),
  actions: {
    openShare(payload?: SharePayload) {
      if (payload) {
        this.songTitle = payload.title
        this.songUuid = payload.uuid
      }
      this.open = true
    },
    closeShare() {
      this.open = false
    },
    reset() {
      this.songTitle = undefined
      this.songUuid = undefined
      this.open = false
    }
  }
})

